import { render, staticRenderFns } from "./CreateManufacturingSite.vue?vue&type=template&id=478584d9&scoped=true&"
import script from "./CreateManufacturingSite.vue?vue&type=script&lang=js&"
export * from "./CreateManufacturingSite.vue?vue&type=script&lang=js&"
import style0 from "./CreateManufacturingSite.vue?vue&type=style&index=0&id=478584d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478584d9",
  null
  
)

export default component.exports